import styled from 'styled-components';
import { button, spacing } from 'ui/theme';

/**
 * Base cell for table,
 * @param {string} data-justify flex justify-content property values
 */
export const Cell = styled.div`
  align-items: center;
  display: flex;
  gap: ${spacing.quarter};
  ${button}

  &[data-justify='center'] {
    justify-content: center;
  }
`;
